// Адаптер к бэкенду timeliner_be для CommentsMoreMenu. Эндпоинты — см. README,
// раздел «Встраивание в timeliner_be». В демо вместо него — адаптер к самому сервису.

import { getToken } from "../../api/axiosInstance";

export function createNleApi({ versionId, apiBase = "/api/v1" }) {
  //const base = `${apiBase}/content-versions/${versionId}/comments`;
  const base = `${apiBase}/version/${versionId}/nle`;
  return {
    exportComments(format, { fps }) {
      const token = getToken();
      const q = new URLSearchParams({ format, fps });
      return fetch(`${base}/export?${q}`, {
        credentials: "include",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    },
    injectProject(file, { fps }) {
      const token = getToken();
      const fd = new FormData();
      fd.append("file", file);
      fd.append("fps", fps);
      return fetch(`${base}/inject`, {
        method: "POST",
        body: fd,
        credentials: "include",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    },
  };
}
